import { WEBAPP_ROUTE_PREFIX } from '../../constants/route'
import i18n from '../../i18n'
import {
  getUserAvatar,
  getUserListItemContentText,
  getUserProfileRoute,
  isContractorUser,
} from '../../utils/user'
import { excludeSpecialCharacters } from '../../utils/validation'
import { Link } from '../Link'

import { USER_FULLNAME_SYSTEM, USER_PROFILE_ACTION } from './User.constants'

export function getUserProfileCanEdit(userData) {
  return !userData?.isArchived && Boolean(userData?.permissions?.can_edit)
}

export function isUserFullnameSystem(fullname) {
  return fullname === USER_FULLNAME_SYSTEM
}

export function isUserProfileActionAddNew(action) {
  return action === USER_PROFILE_ACTION.addNew
}

export function getUserLabel(user) {
  const {
    company_post_name: companyPostName,
    email,
    fullname,
    group,
    is_landlord: isLandlord,
    role,
  } = user

  return user.is_persistent
    ? i18n.t(user.fullname)
    : getUserListItemContentText({
        companyPostName,
        email,
        fullname,
        group,
        isLandlord,
        role,
      })
}

export function toUserSelectItem(user) {
  return {
    additionalData: user.email,
    avatar: getUserAvatar(user),
    email: user.email,
    fullname: user.fullname,
    isArchived: user.archived,
    label: getUserLabel(user),
    role: user.role,
    status: user.status,
    validated: user.validated,
    value: user.id,
  }
}

export function toUserWithPropertyInfoSelectItem(user) {
  return {
    ...toUserSelectItem(user),
    propertyInfo: user.property_info,
  }
}

export function toUserSelectItems(items) {
  return items.map(toUserSelectItem)
}

export function toUserSelectItemsFromOption(items) {
  return items.map(({ label: userData, value }) =>
    toUserSelectItem({ id: value, ...userData })
  )
}

export function toUserWithPropertyInfoSelectItemsFromOption(items) {
  return items.map(({ label: userData, value }) =>
    toUserWithPropertyInfoSelectItem({ id: value, ...userData })
  )
}

export function isContractorUserAccount(user) {
  return isContractorUser(user) || user.is_contractor
}

export function toUserSelectItemsWithoutStatus(items) {
  return items.map(userData => toUserSelectItem({ ...userData, status: null }))
}

export function getUserLinkProps({
  idKey = 'key',
  isExternalContactProfileNGAvailable,
  isProviderProfileNGAvailable,
  isUserProfileNGAvailable,
  link,
  user,
}) {
  const to =
    link ||
    getUserProfileRoute({
      id: user?.[idKey],
      isExternalContactProfileNGAvailable,
      isProviderProfileNGAvailable,
      isUserProfileNGAvailable,
      role: user?.role,
    })

  // If link should be handle outside of `react-router`
  const isExternalLink = to.includes(WEBAPP_ROUTE_PREFIX)
  const LinkComponent = isExternalLink ? 'a' : Link

  return {
    LinkComponent,
    isExternalLink,
    to,
    userLink: isExternalLink ? { href: to } : { to },
  }
}

export function getUserFormNameFieldNextValue(event) {
  const nextEvent = { ...event }

  nextEvent.target.value = excludeSpecialCharacters(event.target.value)

  return nextEvent
}
